export default __webpack_public_path__ + "static/media/XAU.1d2fb1d7.svg";